import axios from "axios";
import { GetAllRIDEntitiesDTO, GetAllRIDFiltersDTO, RIDCreationDTO, RIDEntityDTO, RIDUpdateDTO, RIDUpdateStateDTO } from "./dto";
import { RIDService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { filter } from "jszip";
import { downloadFileFromResponse } from "../../../../utils/download";

export class RIDServiceImpl implements RIDService {

    public CreateRID(data: RIDCreationDTO): Promise<string> {
        return axios.post("/api/document-integration-request",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateRID(data: RIDUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/document-integration-request/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateRIDState(data: RIDUpdateStateDTO, id: string): Promise<void> {
        return axios.put("/api/document-integration-request/update-state/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteRID(id: string): Promise<void> {
        return axios.delete("/api/document-integration-request/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllRID(filters: GetAllRIDFiltersDTO): Promise<GetAllRIDEntitiesDTO> {
        return axios.get("/api/document-integration-request", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                customerId: filters.customerId,
                requestState: filters.requestState,
                year: filters.year
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetRIDById(id: string): Promise<RIDEntityDTO> {
        return axios.get("/api/document-integration-request/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public DownloadRidDocx(data: { id: string, infoType: string }): Promise<void> {
        return axios.post(`/api/download/rid-docx/${data.id}`,
            { infoType: data.infoType },
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                },
                responseType: 'text',
            },

        ).then((response) => {
            downloadFileFromResponse(response.data, `Rid${data.infoType}.docx`, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }
}